import { cn } from '@quadralize/utils'
import { CloseCircle } from '@solar-icons/react'
import type { VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { badgeVariants } from './badge.variants'

interface BadgeProps extends React.ComponentProps<'div'>, VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode
  onRemove?: () => void
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, size, rounded, icon, onRemove, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(badgeVariants({ variant, size, rounded, className }))}
        {...props}
      >
        {icon && <span className="[&_svg]:size-3">{icon}</span>}
        {children}
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="ml-1 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-1 focus:ring-focus-ring"
            aria-label="Remove"
          >
            <CloseCircle weight="Bold" size={12} />
          </button>
        )}
      </div>
    )
  },
)

Badge.displayName = 'Badge'

export { Badge, badgeVariants }
